import React from "react";
import styled from "styled-components";

import FeedbackRow from "components/SatisfactionSurveys/SatisfactionSurveysIndex/Dashboard/SatisfactionFeedback/FeedbackTable/FeedbackRow";
import FeedbackTableSettings from "components/SatisfactionSurveys/SatisfactionSurveysIndex/Dashboard/SatisfactionFeedback/FeedbackTable/FeedbackTableSettings";

const FeedbackTable = props => (
  <div className={props.className}>
    {props.showSettings ? (
      <FeedbackTableSettings
        emailProp={props.emailProp}
        userNameProp={props.userNameProp}
        updateAccountMetaAndFlushMeta={props.updateAccountMetaAndFlushMeta}
      >
        <h4>{props.name}</h4>
      </FeedbackTableSettings>
    ) : (
      <h4>{props.name}</h4>
    )}
    <table className="feedback-table">
      <tbody>
        {props.feedback.length > 0
          ? props.feedback.map((rowData, i) => (
              <FeedbackRow
                rowData={rowData}
                priority={props.priority}
                emailProp={props.emailProp}
                userNameProp={props.userNameProp}
                key={`${rowData.timestamp}-${i}`}
              />
            ))
          : noResponses(`No Feedback ${props.name}`)}
      </tbody>
    </table>
  </div>
);

const noResponses = message => (
  <tr>
    <td className="no-responses">{message}</td>
  </tr>
);

export default styled(FeedbackTable)`
  width: 100%;
  display: flex;
  flex-direction: column;

  h4 {
    margin-bottom: 0;
    min-width: 250px;
    width: 290px;
    text-transform: uppercase;
    color: #c7c7c7;
  }

  .no-responses {
    padding-top: 10px;
    font-style: italic;
    color: #a7a7a7;
    text-align: center;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
`;
